import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { colorToHex } from '../../../../features/pipeline/pipeline-model.ts';

var root = $.from_html(`<div></div>`);
var root_1 = $.from_html(`<div class="preview-col svelte-1j9fleb"><div><div class="canvas-wrap ui-checker-bg svelte-1j9fleb"><canvas class="canvas svelte-1j9fleb"></canvas></div> <div class="ramp-knob-strip svelte-1j9fleb"></div> <div class="stop-knob-strip svelte-1j9fleb"></div></div> <div class="axis-options svelte-1j9fleb"><label class="axis-option svelte-1j9fleb"><input type="radio" name="lut-editor-axis"/> </label> <label class="axis-option svelte-1j9fleb"><input type="radio" name="lut-editor-axis"/> </label></div></div>`);

const $$css = {
	hash: 'svelte-1j9fleb',
	code: '.preview-col.svelte-1j9fleb {display:flex;flex-direction:column;align-items:center;justify-content:center;padding:16px;gap:8px;border-right:1px solid var(--color-line);flex-shrink:0;}.canvas-area.svelte-1j9fleb {display:grid;grid-template-columns:256px 24px;grid-template-rows:256px 24px;}.axis-swapped.svelte-1j9fleb .ramp-knob-strip:where(.svelte-1j9fleb) {grid-row:2;grid-column:1;}.axis-swapped.svelte-1j9fleb .stop-knob-strip:where(.svelte-1j9fleb) {grid-row:1;grid-column:2;}.axis-swapped.svelte-1j9fleb .ramp-knob:where(.svelte-1j9fleb) {left:auto;top:4px;transform:translateX(-50%);cursor:ew-resize;}.axis-swapped.svelte-1j9fleb .pending-delete-ramp:where(.svelte-1j9fleb) {transform:translateX(-50%) scale(0.75);}.axis-swapped.svelte-1j9fleb .stop-knob:where(.svelte-1j9fleb) {top:auto;left:4px;transform:translateY(-50%);cursor:ns-resize;}.axis-swapped.svelte-1j9fleb .pending-delete-stop:where(.svelte-1j9fleb) {transform:translateY(-50%) scale(0.75);}.canvas-wrap.svelte-1j9fleb {position:relative;width:256px;height:256px;border:1px solid var(--color-control-border);border-radius:4px;cursor:crosshair;}.canvas.svelte-1j9fleb {display:block;width:100%;height:100%;image-rendering:pixelated;}.ramp-knob-strip.svelte-1j9fleb {position:relative;grid-row:1;grid-column:2;cursor:crosshair;}.ramp-knob.svelte-1j9fleb {position:absolute;left:4px;width:14px;height:14px;border-radius:50%;background:var(--color-muted);border:2px solid color-mix(in srgb, var(--color-surface-inset), var(--color-bg) 30%);transform:translateY(-50%);cursor:ns-resize;touch-action:none;transition:background 0.1s, box-shadow 0.1s, opacity 0.1s, transform 0.1s;}.selected.svelte-1j9fleb {background:var(--color-accent);box-shadow:0 0 0 2px color-mix(in srgb, var(--color-accent), transparent 60%);}.boundary.svelte-1j9fleb {opacity:0.6;}.pending-delete-ramp.svelte-1j9fleb {background:transparent;border-color:var(--color-warn);box-shadow:0 0 0 2px color-mix(in srgb, var(--color-warn), transparent 40%);opacity:0.55;transform:translateY(-50%) scale(0.75);cursor:no-drop;}.stop-knob-strip.svelte-1j9fleb {position:relative;grid-row:2;grid-column:1;cursor:crosshair;}.stop-knob.svelte-1j9fleb {position:absolute;top:4px;width:14px;height:14px;border-radius:50%;border:2px solid color-mix(in srgb, var(--color-surface-inset), var(--color-bg) 30%);transform:translateX(-50%);cursor:ew-resize;touch-action:none;box-shadow:0 0 0 0 transparent;transition:box-shadow 0.1s, opacity 0.1s, transform 0.1s;}.focused.svelte-1j9fleb {box-shadow:0 0 0 2px var(--color-accent);}.pending-delete-stop.svelte-1j9fleb {background:var(--color-warn) !important;opacity:0.55;box-shadow:0 0 0 2px color-mix(in srgb, var(--color-warn), transparent 40%);transform:translateX(-50%) scale(0.75);border-color:var(--color-warn);cursor:no-drop;}.axis-options.svelte-1j9fleb {display:flex;gap:10px;padding:4px 2px 0;}.axis-option.svelte-1j9fleb {display:flex;align-items:center;gap:4px;font-size:11px;color:var(--color-muted);cursor:pointer;user-select:none;}\n  @media (max-width: 1120px) {.preview-col.svelte-1j9fleb {border-right:none;border-bottom:1px solid var(--color-line);}\n  }'
};

export default function Lut_editor_preview_pane($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const editorRampData = $.prop($$props, 'editorRampData', 7, null),
		selectedRampId = $.prop($$props, 'selectedRampId', 7, null),
		focusedStopId = $.prop($$props, 'focusedStopId', 7, null),
		selectedRamp = $.prop($$props, 'selectedRamp', 7, null),
		draggingRampDeleteId = $.prop($$props, 'draggingRampDeleteId', 7, null),
		draggingStopDeleteId = $.prop($$props, 'draggingStopDeleteId', 7, null),
		isRampBoundary = $.prop($$props, 'isRampBoundary', 7, () => false),
		isStopBoundary = $.prop($$props, 'isStopBoundary', 7, () => false),
		rampRailHint = $.prop($$props, 'rampRailHint', 7, ''),
		stopRailHint = $.prop($$props, 'stopRailHint', 7, ''),
		axisStopXRampYLabel = $.prop($$props, 'axisStopXRampYLabel', 7, ''),
		axisRampXStopYLabel = $.prop($$props, 'axisRampXStopYLabel', 7, ''),
		onCanvasRef = $.prop($$props, 'onCanvasRef', 7, undefined),
		onCanvasClick = $.prop($$props, 'onCanvasClick', 7, () => undefined),
		onRampStripPointerDown = $.prop($$props, 'onRampStripPointerDown', 7, () => undefined),
		onStopStripPointerDown = $.prop($$props, 'onStopStripPointerDown', 7, () => undefined),
		onRampKnobPointerDown = $.prop($$props, 'onRampKnobPointerDown', 7, () => undefined),
		onStopKnobPointerDown = $.prop($$props, 'onStopKnobPointerDown', 7, () => undefined),
		onAxisSwapChange = $.prop($$props, 'onAxisSwapChange', 7, () => undefined),
		onSelectRamp = $.prop($$props, 'onSelectRamp', 7, () => undefined),
		onSelectStop = $.prop($$props, 'onSelectStop', 7, () => undefined);

	let previewCanvasRef = $.state(null);
	let rampKnobStripRef = $.state(null);
	let stopKnobStripRef = $.state(null);
	let notifiedCanvasRef = $.state(null);

	$.user_effect(() => {
		if ($.get(previewCanvasRef) === $.get(notifiedCanvasRef)) {
			return;
		}

		$.set(notifiedCanvasRef, $.get(previewCanvasRef), true);
		onCanvasRef()?.($.get(previewCanvasRef));
	});

	var $$exports = {
		get editorRampData() {
			return editorRampData();
		},

		set editorRampData($$value = null) {
			editorRampData($$value);
			$.flush();
		},

		get selectedRampId() {
			return selectedRampId();
		},

		set selectedRampId($$value = null) {
			selectedRampId($$value);
			$.flush();
		},

		get focusedStopId() {
			return focusedStopId();
		},

		set focusedStopId($$value = null) {
			focusedStopId($$value);
			$.flush();
		},

		get selectedRamp() {
			return selectedRamp();
		},

		set selectedRamp($$value = null) {
			selectedRamp($$value);
			$.flush();
		},

		get draggingRampDeleteId() {
			return draggingRampDeleteId();
		},

		set draggingRampDeleteId($$value = null) {
			draggingRampDeleteId($$value);
			$.flush();
		},

		get draggingStopDeleteId() {
			return draggingStopDeleteId();
		},

		set draggingStopDeleteId($$value = null) {
			draggingStopDeleteId($$value);
			$.flush();
		},

		get isRampBoundary() {
			return isRampBoundary();
		},

		set isRampBoundary($$value = () => false) {
			isRampBoundary($$value);
			$.flush();
		},

		get isStopBoundary() {
			return isStopBoundary();
		},

		set isStopBoundary($$value = () => false) {
			isStopBoundary($$value);
			$.flush();
		},

		get rampRailHint() {
			return rampRailHint();
		},

		set rampRailHint($$value = '') {
			rampRailHint($$value);
			$.flush();
		},

		get stopRailHint() {
			return stopRailHint();
		},

		set stopRailHint($$value = '') {
			stopRailHint($$value);
			$.flush();
		},

		get axisStopXRampYLabel() {
			return axisStopXRampYLabel();
		},

		set axisStopXRampYLabel($$value = '') {
			axisStopXRampYLabel($$value);
			$.flush();
		},

		get axisRampXStopYLabel() {
			return axisRampXStopYLabel();
		},

		set axisRampXStopYLabel($$value = '') {
			axisRampXStopYLabel($$value);
			$.flush();
		},

		get onCanvasRef() {
			return onCanvasRef();
		},

		set onCanvasRef($$value = undefined) {
			onCanvasRef($$value);
			$.flush();
		},

		get onCanvasClick() {
			return onCanvasClick();
		},

		set onCanvasClick($$value = () => undefined) {
			onCanvasClick($$value);
			$.flush();
		},

		get onRampStripPointerDown() {
			return onRampStripPointerDown();
		},

		set onRampStripPointerDown($$value = () => undefined) {
			onRampStripPointerDown($$value);
			$.flush();
		},

		get onStopStripPointerDown() {
			return onStopStripPointerDown();
		},

		set onStopStripPointerDown($$value = () => undefined) {
			onStopStripPointerDown($$value);
			$.flush();
		},

		get onRampKnobPointerDown() {
			return onRampKnobPointerDown();
		},

		set onRampKnobPointerDown($$value = () => undefined) {
			onRampKnobPointerDown($$value);
			$.flush();
		},

		get onStopKnobPointerDown() {
			return onStopKnobPointerDown();
		},

		set onStopKnobPointerDown($$value = () => undefined) {
			onStopKnobPointerDown($$value);
			$.flush();
		},

		get onAxisSwapChange() {
			return onAxisSwapChange();
		},

		set onAxisSwapChange($$value = () => undefined) {
			onAxisSwapChange($$value);
			$.flush();
		},

		get onSelectRamp() {
			return onSelectRamp();
		},

		set onSelectRamp($$value = () => undefined) {
			onSelectRamp($$value);
			$.flush();
		},

		get onSelectStop() {
			return onSelectStop();
		},

		set onSelectStop($$value = () => undefined) {
			onSelectStop($$value);
			$.flush();
		}
	};

	var div = root_1();
	var div_1 = $.child(div);
	var div_2 = $.child(div_1);
	var canvas = $.child(div_2);

	$.bind_this(canvas, ($$value) => $.set(previewCanvasRef, $$value), () => $.get(previewCanvasRef));
	$.reset(div_2);

	var div_3 = $.sibling(div_2, 2);

	$.each(div_3, 21, () => editorRampData()?.ramps ?? [], (ramp) => ramp.id, ($$anchor, ramp) => {
		var div_4 = root();

		$.template_effect(
			($0) => {
				$.set_class(div_4, 1, $0, 'svelte-1j9fleb');

				$.set_style(div_4, editorRampData()?.axisSwap
					? `left:${$.get(ramp).position * 100}%`
					: `top:${$.get(ramp).position * 100}%`);
			},
			[
				() => $.clsx(`ramp-knob ${selectedRampId() === $.get(ramp).id ? 'selected' : ''} ${isRampBoundary()($.get(ramp).id) ? 'boundary' : ''} ${draggingRampDeleteId() === $.get(ramp).id ? 'pending-delete-ramp' : ''}`.trim())
			]
		);

		$.delegated('pointerdown', div_4, (event) => {
			event.preventDefault();
			event.stopPropagation();
			onSelectRamp()($.get(ramp).id);
			onRampKnobPointerDown()($.get(ramp).id, event, $.get(rampKnobStripRef));
		});

		$.append($$anchor, div_4);
	});

	$.reset(div_3);
	$.bind_this(div_3, ($$value) => $.set(rampKnobStripRef, $$value), () => $.get(rampKnobStripRef));

	var div_5 = $.sibling(div_3, 2);

	$.each(div_5, 21, () => selectedRamp()?.stops ?? [], (stop) => stop.id, ($$anchor, stop) => {
		var div_6 = root();

		$.template_effect(
			($0, $1) => {
				$.set_class(div_6, 1, $0, 'svelte-1j9fleb');
				$.set_style(div_6, $1);
			},
			[
				() => $.clsx(`stop-knob ${focusedStopId() === $.get(stop).id ? 'focused' : ''} ${isStopBoundary()($.get(stop).id) ? 'boundary' : ''} ${draggingStopDeleteId() === $.get(stop).id ? 'pending-delete-stop' : ''}`.trim()),
				() => editorRampData()?.axisSwap
					? `top:${$.get(stop).position * 100}%;background-color:${colorToHex($.get(stop).color)}`
					: `left:${$.get(stop).position * 100}%;background-color:${colorToHex($.get(stop).color)}`
			]
		);

		$.delegated('pointerdown', div_6, (event) => {
			event.preventDefault();
			event.stopPropagation();
			onSelectStop()($.get(stop).id);
			onStopKnobPointerDown()($.get(stop).id, event, $.get(stopKnobStripRef));
		});

		$.append($$anchor, div_6);
	});

	$.reset(div_5);
	$.bind_this(div_5, ($$value) => $.set(stopKnobStripRef, $$value), () => $.get(stopKnobStripRef));
	$.reset(div_1);

	var div_7 = $.sibling(div_1, 2);
	var label = $.child(div_7);
	var input = $.child(label);

	$.remove_input_defaults(input);

	var text = $.sibling(input);

	$.reset(label);

	var label_1 = $.sibling(label, 2);
	var input_1 = $.child(label_1);

	$.remove_input_defaults(input_1);

	var text_1 = $.sibling(input_1);

	$.reset(label_1);
	$.reset(div_7);
	$.reset(div);

	$.template_effect(() => {
		$.set_class(div_1, 1, `canvas-area ${editorRampData()?.axisSwap ? 'axis-swapped' : ''}`, 'svelte-1j9fleb');
		$.set_attribute(canvas, 'width', editorRampData()?.width ?? 256);
		$.set_attribute(canvas, 'height', editorRampData()?.height ?? 256);
		$.set_attribute(div_3, 'title', rampRailHint());
		$.set_attribute(div_5, 'title', stopRailHint());
		$.set_checked(input, !editorRampData()?.axisSwap);
		$.set_text(text, ` ${axisStopXRampYLabel() ?? ''}`);
		$.set_checked(input_1, !!editorRampData()?.axisSwap);
		$.set_text(text_1, ` ${axisRampXStopYLabel() ?? ''}`);
	});

	$.delegated('click', div_2, (event) => onCanvasClick()(event, $.get(previewCanvasRef)));
	$.delegated('pointerdown', div_3, (event) => onRampStripPointerDown()(event, $.get(rampKnobStripRef)));
	$.delegated('pointerdown', div_5, (event) => onStopStripPointerDown()(event, $.get(stopKnobStripRef)));
	$.delegated('change', input, () => onAxisSwapChange()(false));
	$.delegated('change', input_1, () => onAxisSwapChange()(true));
	$.append($$anchor, div);

	return $.pop($$exports);
}

$.delegate(['click', 'pointerdown', 'change']);

$.create_custom_element(
	Lut_editor_preview_pane,
	{
		editorRampData: {},
		selectedRampId: {},
		focusedStopId: {},
		selectedRamp: {},
		draggingRampDeleteId: {},
		draggingStopDeleteId: {},
		isRampBoundary: {},
		isStopBoundary: {},
		rampRailHint: {},
		stopRailHint: {},
		axisStopXRampYLabel: {},
		axisRampXStopYLabel: {},
		onCanvasRef: {},
		onCanvasClick: {},
		onRampStripPointerDown: {},
		onStopStripPointerDown: {},
		onRampKnobPointerDown: {},
		onStopKnobPointerDown: {},
		onAxisSwapChange: {},
		onSelectRamp: {},
		onSelectStop: {}
	},
	[],
	[],
	{ mode: 'open' }
);